import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../shared/shared/shared.module';
import { CountryCodeService } from '../../../services/country-code/country-code.service';
import { GeneratedTextGetByKeysComponent } from './generated-text-get-by-keys.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  providers: [
    CountryCodeService,
  ],
  declarations: [
    GeneratedTextGetByKeysComponent,
  ]
})
export class GeneratedTextGetByKeysModule {
}
